import createStore from "astrid-helpers/src/createStore";

export const [getProductionId, setProductionId, useProductionId, onProductionId] = createStore();
